import { render, staticRenderFns } from "./SignatureCapture.vue?vue&type=template&id=01d4f5cd"
import script from "./SignatureCapture.vue?vue&type=script&lang=ts"
export * from "./SignatureCapture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports